var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBombeta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4167 17.512C25.4167 11.8298 21.0434 7.22925 15.6475 7.22925C10.265 7.22925 5.88281 11.8298 5.88281 17.512C5.88281 21.143 8.02682 24.0155 10.3054 26.6636C10.8993 27.2895 11.248 28.1085 11.2877 28.9706C11.2877 29.1142 11.2339 30.4787 11.2339 30.4787H20.0611C20.0611 30.4787 20.0073 29.1322 20.0073 28.9706C20.0482 28.1079 20.3986 27.2888 20.9941 26.6636C23.2726 24.0155 25.4167 21.143 25.4167 17.512Z",
    fill: "#FFDC00",
    stroke: "#434341",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6877 38.2883C17.7041 38.2883 19.3388 37.1469 19.3388 35.7389C19.3388 34.331 17.7041 33.1896 15.6877 33.1896C13.6713 33.1896 12.0366 34.331 12.0366 35.7389C12.0366 37.1469 13.6713 38.2883 15.6877 38.2883Z",
    fill: "#F2C94C",
    stroke: "#434341",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6797 29.6214H11.6105C11.0481 29.6214 10.5923 30.0776 10.5923 30.6402C10.5923 31.2029 11.0481 31.6591 11.6105 31.6591H19.6797C20.242 31.6591 20.6979 31.2029 20.6979 30.6402C20.6979 30.0776 20.242 29.6214 19.6797 29.6214Z",
    fill: "#F2C94C",
    stroke: "#434341",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6797 31.6636H11.6105C11.0481 31.6636 10.5923 32.1197 10.5923 32.6824C10.5923 33.2451 11.0481 33.7013 11.6105 33.7013H19.6797C20.242 33.7013 20.6979 33.2451 20.6979 32.6824C20.6979 32.1197 20.242 31.6636 19.6797 31.6636Z",
    fill: "#F2C94C",
    stroke: "#434341",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6797 33.7013H11.6105C11.0481 33.7013 10.5923 34.1574 10.5923 34.7201C10.5923 35.2828 11.0481 35.739 11.6105 35.739H19.6797C20.242 35.739 20.6979 35.2828 20.6979 34.7201C20.6979 34.1574 20.242 33.7013 19.6797 33.7013Z",
    fill: "#F2C94C",
    stroke: "#434341",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2399 19.8952C17.7286 21.0263 16.7687 21.7893 15.6743 21.7893C14.5799 21.7893 13.6648 21.0622 13.1445 19.967",
    stroke: "#434341",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6877 29.6214V21.7893",
    stroke: "#434341",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6921 1.35852V4.10088",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90601 2.49854L10.9556 5.03443",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00342 5.77057L6.93662 7.70952",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72021 10.6718L4.24997 11.7175",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.562988 16.4527H3.29907",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70215 22.2381L4.2319 21.1923",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97217 27.1484L6.90988 25.2094",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3362 27.1797L24.3984 25.2408",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.615 22.2785L27.0852 21.2327",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7767 16.4976H28.0361",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6328 10.7122L27.103 11.7579",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3673 5.80194L24.4297 7.74089",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4693 2.51648L20.4197 5.05237",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombeta);
export default __webpack_public_path__ + "static/media/bombeta.1bac6d0d8a2b1538bcf2b478fcca4af3.svg";
export { ForwardRef as ReactComponent };